import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "prs" };
const _hoisted_2 = { class: "prs__view" };
const _hoisted_3 = { class: "prs__price" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, "€", -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "prs__divider" }, "-", -1 /* HOISTED */);
const _hoisted_6 = { class: "prs__price" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "€", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            ref: _ctx.setEl,
            id: "price-slider",
            class: "prs__slider"
        }, null, 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.selMin), 1 /* TEXT */)
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.selMax), 1 /* TEXT */)
            ])
        ])
    ]));
}
